module.exports = __webpack_public_path__ + "e8912c2d44c5a7903f9d824b544f3ffd.svg";